import { ReactNode } from "react"
import { useWindowDimensions } from "../../../../hooks/useWindowDimensions"
import { Box } from "@material-ui/core"

export function ChartRootLayoutExpanded({ children }: { children: ReactNode }) {
  const windowDimensions = useWindowDimensions()

  return (
    <Box
      display="flex"
      style={{
        height: windowDimensions.height * 0.75,
        minHeight: 300,
      }}
    >
      {children}
    </Box>
  )
}
